// import external dependencies
import $ from 'jquery';
import TableAccordion from './util/table-accordion.js';
// import Gdpr from './util/gdpr.js';
import ConsentModal from './util/consent-modal.js';

require('./util/bootstrap-menu-collapse');
require('./util/menu-fixer');

var tableAccordion = new TableAccordion();
tableAccordion.init('.table-section', '.accordion', '.readmore');

$(document).ready(function () {
  // Legacy consent banner kept commented out per ticket for easy rollback.
  // eslint-disable-next-line no-undef
  // let gdpr = new Gdpr(options.gdpr);
  //
  // if (!gdpr.check()) {
  //   gdpr.show();
  // }

  new ConsentModal().init();

  $('a').each(function () {
    var a = new RegExp('/' + window.location.host + '/');

    if (!a.test(this.href)) {
      $(this).attr('target', '_blank');
    }
    if (/kreditkortguiden.se\/go\//g.test(this.href)) {
      $(this).attr('target', '_blank');
      $(this).attr('rel', 'sponsored,nofollow');
    }
  });

  const modal_background = $('.c-modal--background');
  const modal = $('.c-modal');

  $('.c-modal--close-button').on('click', () => {
    modal.animate({ opacity: 0 }, 100);
    modal_background.animate({ opacity: 0 }, 100);
    setTimeout(() => {
      modal.hide();
      modal_background.hide();
    }, 450);
  });
});



// WEBPACK FOOTER //
// ./scripts/main.js